import types, { ActionCreators } from './types';

const requestOffers: ActionCreators['RequestOffers'] = (chainId, options = {}) => ({
  type: types.REQUEST_OFFERS,
  options,
  chainId,
});

const offersOK: ActionCreators['OffersOK'] = (offers, request) => ({
  type: types.OFFERS_OK,
  offers,
  request,
});

const offersERR: ActionCreators['OffersERR'] = (request, error) => ({
  type: types.OFFERS_ERR,
  request,
  error,
});

const changePath: ActionCreators['ChangePath'] = (path) => ({
  type: types.CHANGE_PATH,
  path,
});

const updateFilter: ActionCreators['UpdateFilter'] = (filter, value) => ({
  type: types.UPDATE_FILTER,
  filter,
  value,
});

export default {
  requestOffers,
  offersOK,
  offersERR,
  changePath,
  updateFilter,
};
